import { VIEW_TYPE } from 'Pods/ThreeDStudio/Store/constants'

import { EMPTY_OBJECT } from 'Utils/stableDefaults'

const imageAsset = (assetId, fileUrl) => ({
  assetType: 'image',
  source: 'user_upload',
  assetId,
  fileUrl,
})

/**
 * Inverse of parseImageInput. Shapes the image input of the current modelSettings the
 * way the run API returns it, so a just-submitted run reopens with the same uploader
 * state: labelled views for a multi-view run, the reference image otherwise.
 *
 * @param {Object} modelSettings - ThreeDStudio modelSettings slice
 * @returns {Object} openedModel fields for the image input
 */
export const buildImageInput = ({
  isMultiView, inputImage, inputImageUrl, inputViewImages,
} = EMPTY_OBJECT) => {
  if (isMultiView) {
    const inputAssets = Object.values(VIEW_TYPE)
      .filter(viewType => inputViewImages?.[viewType]?.id != null)
      .map(viewType => ({
        ...imageAsset(inputViewImages[viewType].id, inputViewImages[viewType].url),
        viewType,
      }))

    return { multiviewInput: true, inputAssets: inputAssets.length > 0 ? inputAssets : undefined }
  }

  return { inputAssets: inputImage != null ? [imageAsset(inputImage, inputImageUrl)] : undefined }
}
